import { StyleSheet, View } from '@react-pdf/renderer';
import { useCallback } from 'react';
import { Customer } from '../../../../../interfaces/customer.interface';
import { CustomersTableLinePdf } from './CustomersTableLinePdf';

interface Props {
  customers: Customer[];
  startIndex?: number;
}

export const CustomersReportTableListPdf = ({ customers, startIndex = 0 }: Props) => {
  const getItems = useCallback(() => {
    return customers?.map((item, index) => {
      const globalIndex = startIndex + index;
      return <CustomersTableLinePdf key={globalIndex} index={globalIndex} customer={item} />;
    });
  }, [customers, startIndex]);

  return <View style={styles.container}>{getItems()}</View>;
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    flexWrap: 'nowrap',
    padding: 2,
  },
});
